<template>
    <div class="app-container">
        <!-- 学生搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true"  label-width="70px">
    
      <!-- 作品名称搜索 -->
      <el-form-item label="作品名称" prop="workTitle">
        <el-input v-model="queryParams.workTitle" placeholder="请输入作品名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

       <el-form-item label="学期" prop="xueQi">
        <el-select
          v-model="queryParams.xueQi"
          placeholder="请选择学期"
          clearable
          size="small"
          style="width: 115px"
        >
          <el-option
            v-for="item in semesterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </el-form-item>
     
      <el-form-item label="阶段" prop="stage">
        <el-select
          v-model="queryParams.stage"
          placeholder="请选择阶段"
          clearable
          size="small"
          style="width: 115px"

        >
          <el-option
            v-for="item in stageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- 评价等级搜索 -->
      <el-form-item label="评价状态" prop="commentLevel">
        <el-select v-model="queryParams.commentLevel" placeholder="请选择评价状态" clearable size="small" >
          <el-option label="合格" value="合格" />
          <el-option label="优秀" value="优秀" />
          <el-option label="良好" value="良好" />
          <el-option label="留校" value="留校" />
           <el-option label="未点评" value="未点评" />
        </el-select>
      </el-form-item>

      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
      </el-form>

   
            <div v-for="stage in validStages" :key="stage" :class="`stage-section jieduan${stage}`">
                <h4 class="stage-title">{{ getStageName(stage) }}</h4>
                <el-row :gutter="20">
                    <el-col :span="6" v-for="(image, index) in stageGroups[stage]"
                        :key="`${image.id}-${image.stage}-${index}`">
                        <div class="image-wrapper" @click="setPage('workcomm', image.id)">
                            <div class="image-container">
                                <el-image :src="image.workMedia" class="fit-image" lazy></el-image>
                                <div class="comment-level" v-if="image.commentLevel=='留校'">
                                    <el-image :src="`/images/${getLevelImageName(image.commentLevel)}.png`"
                                        class="level-img" fit="contain" :alt="image.commentLevel"></el-image>
                                </div>
                            </div>
                            <div class="image-text">{{ image.workTitle }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- 无作品提示 -->
            <div v-if="allWorksSorted.length === 0" class="no-works">
                课程尚未开始，暂未产生作品记录
            </div>
     

        <!-- 分页组件
        <div class="block" v-show="allWorks.length > 64">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="currentPage" :page-size="pageSize" class="pagination"
                layout="prev, pager, next,total" :total="allWorksSorted.length"></el-pagination>
        </div> -->

         <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="allWorks.length > 64" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
</template>

<script>
import { Loading } from 'element-ui';
import store from '@/store';
import { mapGetters } from 'vuex';
import { getStageConfigByMajorAndXueQi } from '@/api/system/stageconfig.js';
import { getUserProfile } from '@/api/system/user.js';
import { listStudentWorksByUserID } from '@/api/OmdWorks/works'

export default {
    data() {
        return {
            userId: sessionStorage.getItem("user"),
            allWorks: [], // 所有作品（不分页）
            currentPage: 1, // 前端分页当前页
            pageSize: 64, // 每页条数
            message: '',
            currentMajorId: '',
            currentMajorName: '',
            loadingInstance: null,
            stageConfig: {}, // 存储从接口获取的阶段配置：{ 阶段号: 名称 }
            
            // 查询参数
            queryParams: {
                workTitle: null,   // 作品名称
                xueQi: null,       // 学期
                stage: null,        // 阶段
                commentLevel: null, // 评价状态
                userId: '',        // 用户ID
                pageNum: 1,
                pageSize: 1000
            },
            
            // 学期选项
            semesterOptions: [
                { value: '1', label: '第1学期' },
                { value: '2', label: '第2学期' },
                { value: '3', label: '第3学期' },
                { value: '4', label: '第4学期' },
                { value: '5', label: '第5学期' },
                { value: '6', label: '第6学期' }
            ],
            
            // 阶段选项
            stageOptions: [
                { value: 1, label: '第一阶段' },
                { value: 2, label: '第二阶段' },
                { value: 3, label: '第三阶段' },
                { value: 4, label: '第四阶段' },
                { value: 5, label: '第五阶段' },
                { value: 6, label: '第六阶段' },
                { value: 7, label: '第七阶段' },
                { value: 8, label: '第八阶段' }
            ]
        }
    },
    computed: {
        ...mapGetters(['getCurrentXueQi']),
        // 按阶段分组（key: 阶段1-8，value: 该阶段的作品列表）
        stageGroups() {
            // 先筛选当前页的作品，再按阶段分组
            return this.currentPageWorks.reduce((groups, item) => {
                const stage = item.stage;
                if (stage >= 1 && stage <= 8) { // 只处理1-8阶段
                    if (!groups[stage]) groups[stage] = [];
                    groups[stage].push(item);
                }
                return groups;
            }, {});
        },
        // 排序后的所有作品（简化逻辑）
        allWorksSorted() {
            // 如果数据库已按 stage 排序，直接返回拷贝即可
            return [...this.allWorks];
        },
        // 当前页作品（保持不变）
        currentPageWorks() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.allWorksSorted.slice(startIndex, endIndex);
        },
        // 只返回有作品的阶段
        validStages() {
            return Array.from({ length: 8 }, (_, i) => i + 1) // [1, 2, ..., 8]
                .filter(stage => this.stageGroups[stage]?.length > 0);
        }
    },
    created() {
        this.queryParams.xueQi = this.getCurrentXueQi;
        // 1. 先获取用户资料（含专业ID）
        this.getProfileInfo();
        this.loadingInstance = Loading.service({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
        });
    },
    watch: {
        '$store.state.currentXueQi'(newVal) {
            if (newVal) {
                this.queryParams.xueQi = newVal;
                console.log('当前学期', this.queryParams.xueQi);
                this.currentPage = 1; // 切换学期重置页码
                this.getStageConfig1(); // 先获取阶段配置
                this.getWorks();
            }
        }
    },
    methods: {
        // 将中文评价等级转换为对应的图片文件名
        getLevelImageName(level) {
            const levelMap = {
                '合格': 'hege',
                '优秀': 'youxiu',
                '留校': 'liuxiao',
                '良好': 'lianghao',
            };
            return levelMap[level] || ''; // 如果找不到对应关系，返回空字符串
        },
        
        // 搜索处理
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getWorks();
        },
        
        // 重置搜索
        resetQuery() {
            this.queryParams = {
                workTitle: null,
                xueQi: this.getCurrentXueQi,
                stage: null,
                commentLevel: null,
                userId: this.userId,
                pageNum: 1,
                pageSize: 1000
            };
            this.getWorks();
        },

        // 直接在组件内调用getProfile接口
        async getProfileInfo() {
            try {
                const res = await getUserProfile(); // 调用接口获取资料
                if (res.code === 200) {
                    // 2. 从接口返回结果中提取majorId
                    this.currentMajorId = res.major.majorId;
                    this.currentMajorName = res.major.majorName;
                    // 3. 拿到专业ID后，再加载阶段配置和作品
                    this.getStageConfig1();
                    this.getWorks();
                }
            } catch (err) {
                console.error('获取专业ID失败', err);
                this.loadingInstance?.close();
            }
        },

        // 从接口获取当前学期的阶段配置
        getStageConfig1() {
            // 假设接口需要 专业ID 和 学期 参数（需根据实际接口调整）
            const params = {
                majorId: this.currentMajorId, // 需从当前作品或登录信息中获取专业ID
                xueQi: this.queryParams.xueQi
            };

            getStageConfigByMajorAndXueQi(params).then(res => {
                if (res.code === 200) {
                    // 转换为 { stage: name } 格式（如 {1: '美妆基础', 2: '编发设计'}）
                    this.stageConfig = res.data.reduce((obj, item) => {
                        obj[item.stage] = item.stageName;
                        return obj;
                    }, {});
                    console.log(this.stageConfig);
                }
            });
        },
        
        // 动态获取阶段名称（替代原来的 getStageName）
        getStageName(stageNum) {
            // 优先使用接口获取的名称，无则显示默认值
            return `第${stageNum}阶段\t${this.stageConfig[stageNum] || '未命名阶段'}`;
        },
        
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 改变页大小时重置到第一页
        },
        
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        getWorks() {
            this.loadingInstance = Loading.service({ lock: true, text: '加载中...' });
            this.queryParams.userId = this.userId;
            this.queryParams.xueQi = this.getCurrentXueQi;
            this.queryParams.pageNum = 1;

            listStudentWorksByUserID(this.queryParams).then(res => {
                this.allWorks = res.rows || []; // 获取所有作品
                this.loadingInstance.close(); // 请求完成后关闭
                console.log(res)
            }).catch((error) => {
                console.error(error);
                this.loadingInstance.close(); // 请求失败也关闭加载提示
            });
        },
        
        // 切换到行情页
        setPage(pageName, id) {
            const currentIndex = this.allWorksSorted.findIndex(item => item.id === id);
            sessionStorage.setItem('myWorks_worksList', JSON.stringify(this.allWorksSorted));
            sessionStorage.setItem('myWorks_currentIndex', currentIndex);
            sessionStorage.setItem('workId', id);
            store.commit('page/setPage', pageName);
            this.mian = '详情';
        }
    }
}
</script>

<style scoped>
/* 主容器样式 - 确保在不同设备上正确布局 */
.app-container {
  padding: 20px;
  min-height: calc(100vh - 60px); /* 确保最小高度适应不同屏幕 */
  box-sizing: border-box; /* 确保内边距不影响总尺寸 */
}

/* 搜索表单样式 - 与WorksMain保持一致 */
.search-form {
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-wrap: wrap; /* 确保在小屏幕上能正确换行 */
}

/* 阶段标题样式 */
.stage-section {
  margin: 20px 0;
  padding: 15px;
  border-radius: 8px; /* 添加圆角使外观更统一 */
}

.stage-title {
  font-size: 18px;
  margin-bottom: 15px;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}

/* 阶段颜色样式 */
.jieduan1 { background-color: #fff1f4; }
.jieduan2 { background-color: #f6e0e2; }
.jieduan3 { background-color: #f4cacc; }
.jieduan4 { background-color: #f1b3b9; }
.jieduan5 { background-color: #ed999f; }
.jieduan6 { background-color: #e87f86; }
.jieduan7 { background-color: #e2666d; }
.jieduan8 { background-color: #da4d55; }

/* 无作品提示 */
.no-works {
  text-align: center;
  padding: 50px 0;
  color: #666;
  font-size: 16px;
}

/* 图片网格样式 - 确保跨浏览器兼容 */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  padding: 10px 0px;
}

/* 图片容器 - 使用aspect-ratio确保宽高比一致 */
.image-wrapper {
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 
              0 6px 20px rgba(224, 34, 77, 0.08);
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%; /* 确保高度自适应 */
  display: flex;
  flex-direction: column;
  margin-bottom: 30px; /* 每个图片下方的间隔 */
}

.image-wrapper:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15),
              0 10px 30px rgba(224, 34, 77, 0.18);
}

.image-container {
  position: relative;
  aspect-ratio: 4/3; /* 使用现代宽高比属性 */
  background-color: #f9f9f9;
}

.fit-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保图片始终填充容器 */
  display: block; /* 避免图片下方间隙 */
}

/* 评价标志 - 确保跨浏览器兼容 */
.comment-level {
  position: absolute;
  right: 5px;
  bottom: 5px;
  z-index: 10;
  width: 22%; /* 响应式大小 */
  max-width: 90px; /* 最大尺寸 */
  min-width: 60px; /* 最小尺寸 */
  height: auto; /* 高度自适应 */
  aspect-ratio: 1/1; /* 保持正方形 */
}

.level-img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片完整显示 */
}

.image-text {
  text-align: center;
  padding: 10px;
  color: #de336c;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  flex-shrink: 0; /* 防止文字区域压缩 */
}

/* 分页样式 - 确保在不同设备上居中显示 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 15px 0;
}
/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
/* 响应式调整 */
@media (max-width: 1200px) {
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}

@media (max-width: 992px) {
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
  
  .image-text {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .app-container {
    padding: 10px;
  }
  
  .search-form {
    padding: 10px;
  }
  
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }
  
  .comment-level {
    width: 25%;
    max-width: 70px;
    min-width: 50px;
  }
  
  .image-text {
    font-size: 0.85rem;
    padding: 8px;
  }
  
  .stage-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 10px;
  }
  
  .comment-level {
    width: 28%;
    max-width: 60px;
    min-width: 45px;
  }
  
  .image-text {
    font-size: 0.8rem;
    padding: 6px;
  }
}
</style>